<template src="./templates/IconRenderer.html" />

<script setup>

import { defineProps, onMounted, ref } from 'vue';

// eslint-disable-next-line
const { svg } = defineProps(['svg']);

const iconContainer = ref(null);

onMounted(() => {

    if (svg) {

        iconContainer.value.innerHTML = svg;

    }

});

</script>
